import { createFileRoute } from "@tanstack/react-router";
import { requireRoutePermission } from "../../route-authorization";
import { RoutedDashboardPage } from "../../dashboard-page-context";

export const Route = createFileRoute("/app/company-setup")({
  beforeLoad: () => requireRoutePermission([
    "companies.manage",
    "reporting_entities.manage",
    "operating_locations.manage",
  ]),
  component: RoutedDashboardPage,
});
